// frontend/src/design-system/components/StatCard.tsx
import * as React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
import { VISUAL } from '../visual';

interface Props {
  /** Optional eyebrow caption above the number. */
  label: string;
  /** The number (already-formatted string preferred — e.g. "12,540" or "$3,210"). */
  value: React.ReactNode;
  /** Sub-line under the number. */
  hint?: React.ReactNode;
  /** Optional icon shown in upper-right. */
  icon?: React.ReactNode;
  className?: string;
}

export function StatCard({ label, value, hint, icon, className }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{
        y: -2,
        transition: { type: 'spring', stiffness: 320, damping: 22 },
      }}
      transition={{ type: 'spring', stiffness: 220, damping: 26 }}
      className={cn(VISUAL.card, VISUAL.cardHover, 'p-6', className)}
    >
      <div className="flex items-start justify-between gap-4 mb-3">
        <span className={VISUAL.eyebrow}>{label}</span>
        {icon && <div className="text-muted-foreground/70 [&_svg]:h-4 [&_svg]:w-4">{icon}</div>}
      </div>
      <div className={VISUAL.heroNumber}>{value}</div>
      {hint && <div className="text-sm text-muted-foreground mt-2">{hint}</div>}
    </motion.div>
  );
}
